'use client';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EcoImg from 'eco-design/base/eco-img';
import { useState } from 'react';
import LeftIcon from './icons/leftIcon';
import RightIcon from './icons/rightIcon';
import './index.scss';

type StoryItem = {
    pc: string;
    h5?: string;
    name: string;
    text: string;
};

export default function IndexClient({ list, prefixCls, id }: { list: StoryItem[]; prefixCls: string; id: string }) {
    const [openIdx, setOpenIdx] = useState<number[]>([]);
    const showNav = list.length > 1;
    const navScope = `#editor-${id}`;
    const handleOpenIdx = (i: number) => {
        let newIdx = [...openIdx];
        if (newIdx.includes(i)) {
            newIdx = newIdx.filter((j: number) => i !== j);
        } else {
            newIdx.push(i);
        }
        setOpenIdx(newIdx);
    };

    return (
        <div className={`${prefixCls}-items ${prefixCls}-items-${id}`}>
            <div className={`${prefixCls}-carousel`}>
                {showNav && (
                    <button type="button" className={`${prefixCls}-nav-prev swiper-button-prev`} aria-label="Vorige">
                        <LeftIcon />
                    </button>
                )}
                <Swiper
                    className={`${prefixCls}-swiper`}
                    modules={showNav ? [Navigation] : []}
                    navigation={
                        showNav
                            ? {
                                  prevEl: `${navScope} .${prefixCls}-nav-prev`,
                                  nextEl: `${navScope} .${prefixCls}-nav-next`,
                              }
                            : undefined
                    }
                    spaceBetween={12}
                    slidesPerView="auto"
                >
                    {list.map((item, i: number) => {
                        const { pc, h5, name, text } = item;
                        return (
                            <SwiperSlide className={`${prefixCls}-swiper-slide ${prefixCls}-item ${openIdx.includes(i) ? 'open' : ''}`} key={i}>
                                <EcoImg className={`${prefixCls}-item-img`} pc={pc} pad={pc} h5={h5 || pc} alt={name} />
                                <div className={`${prefixCls}-item-info`}>
                                    <p className={`${prefixCls}-item-text`}>{text}</p>
                                    <div className={`${prefixCls}-item-name`} onClick={() => handleOpenIdx(i)}>
                                        <span>{name}</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M18 9L12 15L6 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
                {showNav && (
                    <button type="button" className={`${prefixCls}-nav-next swiper-button-next`} aria-label="Volgende">
                        <RightIcon />
                    </button>
                )}
            </div>
        </div>
    );
}
